import { useAuth } from "../context/AuthContext";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

const AdminPage = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div data-testid="admin-loading" className="min-h-screen bg-forest flex items-center justify-center">
        <p className="text-white/80 font-heading uppercase tracking-widest text-sm">Chargement…</p>
      </div>
    );
  }

  return user && user.role === "admin" ? <AdminDashboard /> : <AdminLogin />;
};

export default AdminPage;